export class Modal {
    state: string;
    constructor(){
        this.state = "active";
    }
}